/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-case-declarations */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState, useCallback, useEffect } from 'react';
import Checkbox from 'react-custom-checkbox';
import { connect } from 'react-redux';
import * as Icon from 'react-icons/fi';
import CustomFilter from '../DistributorManagement/CustomFilters';
import { distributorService } from '../../service/distributor.service';
import { createUrl } from '../../redux/helper/CreateQuery';
import { DistributorActions } from '../../redux/actions';
import { FilterPayloadConstruction } from '../../redux/helper/FIlterPayloadConstructor';
import ThreeDotsLoader from '../../Components/LoadingDots';

function FilterModal({
    setFilterModal, filterModal, setThreeplList, threeplList, setMainCategory, mainCategory, stockdetailsList, setStockDetailsList, Filter, setFilter, handleFilter, setfilterValue, filterValue, handleFetchFGStockDetails, threeDotLoader, setThreeDotsLoader,
}) {
    const [selectedType, setselectedType] = useState('main_category');
    const [result, setresult] = useState([]);
    const [Segments, setSegments] = useState([]);
    const [loading, setloading] = useState(false);

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateFilterQuery = (val) => {
        setThreeDotsLoader(true);
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'item_code':
                if (Filter[key].length > 0) {
                    final += `&item_code=${createUrl(Filter[key])}`;
                }
                break;
            case 'product_categories':
                const productCategories = FilterPayloadConstruction(result);
                if (productCategories.length > 0) {
                    Filter[key] = productCategories;
                    setFilter(Filter);
                    final += `&product_categories=${productCategories.join(',')}`;
                }
                break;
            default: break;
            }
            return final;
        });
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        setThreeDotsLoader(false);
        return final;
    };
    function transform(object, newid, id1) {
        if (Object.keys(object).length > 0) {
            return Object
                .entries(object).filter(([keyVal, value]) => value !== '' && keyVal !== '')
                .map(([name, value]) => {
                    if (value.hasOwnProperty('')) {
                        Object.keys(value).map((key) => key === '' && delete value[key]);
                    }
                    if (value !== '') {
                        const con = {
                            name,
                            ...(value && typeof value === 'object' && !value.hasOwnProperty('')
                                ? {
                                    newid: `${id1++}-${name}`,
                                    id: `${newid === '' ? '' : `${newid}.`}${name}`,
                                    items: transform(value, `${newid === '' ? '' : `${newid}.`}${name}`, Object.keys(object).length),
                                }
                                : { newid: `${id1++}-${name}`, id: `${newid === '' ? '' : `${newid}.`}${name}` }),
                        };
                        Filter?.product_categories?.forEach((element) => {
                            if (con.status === 1) return;
                            // match on '.' segment boundaries so e.g. 'OTHERS' doesn't match 'OTHERS (ACAG ETC)'
                            if (con.id === element || con.id.startsWith(`${element}.`)) {
                                con.status = 1;
                            } else if (element.startsWith(`${con.id}.`)) {
                                con.status = -1;
                            }
                        });
                        return con;
                    }
                });
        }
    }

    const handleClear = () => {
        setFilter((prevState) => ({
            ...prevState,
            item_code: [],
            plant_name: [],
            product_categories: [],
        }));
        setfilterValue('');
        handleFetchFGStockDetails();
        setFilterModal(false);
    };

    const handleCheckBox = (item, segments, temp1) => {
        let copy = [];
        if (segments) {
            copy = [...Segments];
        } else {
            copy = [...checkBox];
        }
        let keyval = item;
        if (copy.includes(item)) {
            keyval = item.split('.')[item.split('.').length - 1];
            const parentKeyValue = item.split('.')[item.split('.').length - 2];
            let idx;
            const Duplicates = [];
            copy.map((val, i) => {
                if (val?.split('.').includes(keyval)) {
                    Duplicates.push(copy.indexOf(val));
                }
            });
            if (Duplicates.length > 1) {
                idx = Duplicates[Duplicates.length - 1];
            } else {
                idx = copy.indexOf(item);
            }
            copy.splice(idx, 1);
            const removeArr = [];
            copy.map((val) => {
                if (!val?.split('.').includes(keyval)) {
                    removeArr.push(val);
                }
            });
            let parentCount = 0;
            copy.map((val) => {
                if (val?.split('.').includes(parentKeyValue)) {
                    parentCount += 1;
                }
            });
            copy = removeArr;
        } else {
            if (item.split('.').length === 0) {
                copy.push(item);
            } else {
                let temp = '';
                item.split('.').map((val, i) => {
                    temp += i === 0 ? `${val}` : `.${val}`;
                    if (!copy.includes(temp)) {
                        copy.push(temp);
                    }
                });
                keyval = item.split('.')[item.split('.').length - 1];
            }
            if (segments === undefined) {
                findSegmnet(Filters, keyval, copy);
            }
        }
        if (segments) {
            setSegments(copy);
        } else {
            setcheckBox(copy);
        }
    };

    const handleFetchFilters = useCallback((() => {
        distributorService.GetAllProductsFiters().then((res) => {
            if (res.data.success_status) {
                const data = transform(res.data.data, '', 1);
                setresult(data);
            }
        });
    }), []);

    useEffect(() => {
        handleFetchFilters();
    }, []);

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[570px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}

                        >
                            {' '}
                            <img src="/images/close.svg" alt="icon" />
                        </button>

                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[40%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={() => setselectedType('main_category')}>
                                    <a
                                        href="javascript:void(0)"
                                        className={`nav-link block ${selectedType === 'main_category' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-priceranje"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pricetab"
                                        role="tab"
                                        aria-controls="pills-price"
                                        aria-selected="true"
                                    >
                                        Categories
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[75%] h-[350px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane ${selectedType === 'main_category' ? 'show active' : ''} fade px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="modal-body relative pb-5 px-10 flex justify-center flex-col">
                                        <div className="h-[250px] overflow-auto mt-[26px] dropdown-menu cursor-pointer">
                                            {result?.length > 0 && (
                                                <CustomFilter
                                                    result={result}
                                                    Segments={Segments}
                                                    handleCheckBox={handleCheckBox}
                                                />
                                            )}

                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'threepllocation' ? 'show active' : ''} fade px-3 w-full overflow-auto h-[220px] scrollbar-menu`} id="pills-plant" role="tabpanel" aria-labelledby="plant-warehouse">
                                    <div className="ml-5 cursor-pointer">
                                        {threeplList.length > 0 && threeplList.map((location) => (
                                            <div className="flex items-center">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.plant_name?.includes(location.ORGANIZATION_ID) ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.plant_name.includes(location.ORGANIZATION_ID)}
                                                    onChange={() => HandleFilter('plant_name', location.ORGANIZATION_ID)}
                                                    borderColor={`${Filter.plant_name.includes(location.ORGANIZATION_ID) ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn40" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">{location.DESCRIPTION}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[40%] mr-4">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}
                                >
                                    {threeDotLoader ? <div className="pl-[141px]"><ThreeDotsLoader /></div> : ' Apply Filter'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    const { Products, FilterData } = state;
    return { Products, FilterData };
};
const mapDispatchToProps = {
    // GetProductList: DistributorActions.ProductListing,
    // handleSegments: DistributorActions.handleFiltersData,
    // GetCartItems: DistributorActions.GetCartItems,
    handleFiltersData: DistributorActions.handleFiltersData,
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterModal);

// export default FilterModal;
